import { action, makeObservable, observable } from "mobx";

import { NavigateFunction } from "react-router-dom";
import { PieDataObject } from "../../../../organisations/organisationDashboard/models/dashboard_interfaces";
import Pages from "../../../../../../routes/InsightRoutes";
import ModalContext from "../../../../../../core/modalZ/context/ModalContext";
import UsersApi, { UsersApi as IUsersApi } from "../../../../../../services/api/v2/users/Users.api";
import { BaseModel } from "../../../../../../core/util/BaseModel";
import { RAG_STATUS_OPTIONS } from "../../../../../../constants";
import I18n from "../../../../../../core/localization/I18n";
import {
  ActionColDefFieldNamesEnum,
  CommonColDefFieldNamesEnum
} from "../../../../../../core/grids/builder/enums/AgGridColDefFieldNameEnum";
import {
  externalFilterParamKey,
  FilterCellDataTypes,
  JoinOperators,
  UrlOperators
} from "../../../../../../core/grids/builder/directorBuilder/grids/base/addons/FilterAddon/FilterAddonContants";
import { ExtFilterParamBuild } from "../../../../../../core/grids/builder/directorBuilder/utils/helpers";

export class ActionsPerProjectbyRagStatusSidebarModel extends BaseModel {
  userProvider: IUsersApi;
  @observable isLoading = true;
  @observable.ref drillDownPieData: PieDataObject[];
  organisationId: number;
  userId: number;
  ragStatus: number;
  pieColors: string[];
  navigate: NavigateFunction;
  authUser: FP.Entities.IUser;

  constructor(
    authUser: FP.Entities.IUser,
    organisationId: number,
    userId: number,
    ragStatus: number,
    navigate: NavigateFunction
  ) {
    super();
    makeObservable(this);
    this.userProvider = UsersApi;
    this.organisationId = organisationId;
    this.userId = userId;
    this.authUser = authUser;
    this.ragStatus = ragStatus;
    this.navigate = navigate;
    this.pieColors = [
      "#fdd886",
      "#ffc036",
      "#feae95",
      "#f49d4e",
      "#dc9700",
      "#f7820d",
      "#cc660a",
      "#966700",
      "#ed7650",
      "#ac5337",
      "#8a4100",
      "#452015"
    ];
  }

  onMount = async () => {
    await this.loadPieData();
  };

  loadPieData = async () => {
    const userProjects = await this.userProvider.getProjectsWithActionsByRagStatusAndUserId(
      this.organisationId,
      this.userId,
      this.ragStatus
    );

    const res = userProjects.payload.map(usrProj => {
      return {
        id: usrProj.id,
        label: usrProj.label,
        value: usrProj.value,
        color: ""
      };
    });

    this.setModalPieData(res);
    return true;
  };

  getPieColors = () => {
    const result = [...this.pieColors];
    const zeroIndexHasValue = this.drillDownPieData[0].value > 0;
    const zeroIndexIsNoAccessProject = this.drillDownPieData[0].label === "Projects with no access";
    if (zeroIndexHasValue && zeroIndexIsNoAccessProject) result.unshift("#E5E5E5");
    return result;
  };

  @action
  setModalPieData = (data: PieDataObject[]) => {
    this.drillDownPieData = data;
    this.isLoading = false;
  };

  onPieClick = onClickData => {
    const link = `${Pages.projects.actions.listView.generateLink(this.organisationId, onClickData.id)}?${
      ActionColDefFieldNamesEnum.RagStatus
    }=${I18n.get(RAG_STATUS_OPTIONS.find(e => e.key === this.ragStatus).label)}&${GetOrUrlExtension(
      this.authUser.firstName,
      this.authUser.lastName
    )}`;
    this.navigate(link);
    ModalContext.hide();
  };
}

export const GetOrUrlExtension = (firstName, lastName) => {
  const owner = ExtFilterParamBuild(
    CommonColDefFieldNamesEnum.Owner,
    FilterCellDataTypes.text,
    UrlOperators.contains.symbol,
    `${firstName}%20${lastName}`
  );
  const assignee = ExtFilterParamBuild(
    ActionColDefFieldNamesEnum.AssignedTo,
    FilterCellDataTypes.text,
    UrlOperators.contains.symbol,
    `${firstName}%20${lastName}`
  );

  return `${externalFilterParamKey.extFilter}${UrlOperators.equals.symbol}${owner}${JoinOperators.or.symbol}${assignee}`;
};
